/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Modal } from 'antd'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import lock from 'image/no_auth/empty_pop_pic@2x.png'
import qrcode from 'image/code.png'
import './index.less'

const NOAUTH = '您的账号暂无权限访问,请联系团队管理员配置权限'

class NotAuthPop extends Component {
  render() {
    return (
      <Modal
        centered
        visible={this.props.visible}
        footer={null}
        width={480}
        onCancel={() => this.props.onCancel({ visible: false })}
      >
        <div className="download-notallow-wrap">
          <img src={lock} width="86" />
          <div className="notallow-des">
            {teamHasAuth(this.props.code) ? NOAUTH : `购买或者升级版本后，即可${this.props.desc}`}
          </div>
          <div className="notallow-des-tip">微信扫描下方二维码，立即咨询</div>
          <div className="notallow-img">
            <img src={qrcode} alt="" />
          </div>
        </div>
      </Modal>
    )
  }
}

let div = document.createElement('div')
function destory() {
  const unmountResult = ReactDOM.unmountComponentAtNode(div)
  if (unmountResult && div.parentNode) {
    div.parentNode.removeChild(div)
  }
}

export const notAllow = {
  show(param) {
    div = document.createElement('div')
    document.body.appendChild(div)
    ReactDOM.render(<NotAuthPop {...param} visible onCancel={destory.bind(this)} />, div)
  }
}

export default NotAuthPop
